export const NAVY = "#0E2550";
export const MINT = "#14B88F";

export function BrowserFrame({ title, children, className = "", tid }) {
  return (
    <div className={`rounded-2xl border border-slate-200 bg-white shadow-[0_24px_60px_-28px_rgba(14,37,80,0.35)] overflow-hidden ${className}`}
      role="img" aria-label={`Exemplo do ImoDesk com dados fictícios: ${title}`} data-testid={tid}>
      <div className="flex items-center gap-1.5 px-4 h-8 border-b border-slate-100 bg-slate-50/80">
        <span className="w-2 h-2 rounded-full bg-slate-200" /><span className="w-2 h-2 rounded-full bg-slate-200" /><span className="w-2 h-2 rounded-full bg-slate-200" />
        <span className="ml-3 text-[11px] text-slate-400 truncate">Casa Atlântico · {title}</span>
      </div>
      <div className="p-4 sm:p-5">{children}</div>
    </div>
  );
}

export function PhoneFrame({ title, children, className = "", tid, dark = false }) {
  return (
    <div className={`mx-auto w-[248px] rounded-[2.2rem] p-2 shadow-[0_30px_70px_-30px_rgba(0,0,0,0.45)] ${dark ? "bg-white/10" : "bg-slate-900"} ${className}`}
      role="img" aria-label={`Exemplo do ImoDesk no telemóvel com dados fictícios: ${title}`} data-testid={tid}>
      <div className="rounded-[1.8rem] bg-white overflow-hidden">
        <div className="h-6 grid place-items-center"><span className="w-16 h-1.5 rounded-full bg-slate-200" /></div>
        <div className="px-4 pb-5">{children}</div>
      </div>
    </div>
  );
}

export const Line = ({ w = "w-full", className = "" }) => <span className={`block h-2 rounded-full bg-slate-100 ${w} ${className}`} />;

export function Pill({ tone = "ok", children }) {
  const s = { ok: ["#E9F8F3", "#0B7A5E"], warn: ["#FFF6E5", "#9A5B00"], bad: ["#FDECEC", "#B42318"], info: ["#EEF2F8", NAVY] }[tone];
  return <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10.5px] font-semibold whitespace-nowrap" style={{ background: s[0], color: s[1] }}>{children}</span>;
}
